import { get } from '~/utils/ajax';
import { settings } from '~/utils/settings';

type ContentStateType = {
    coupons: ICoupon[];
};

export async function syncContentState(): Promise<ContentStateType> {
    return await get(settings.urls.contentStateSyncUrl);
}
